<template>
  <div class="container">
    <headBox title="长险续费单"></headBox>
    <div class="info-content">
      <ath-title :num="num" :renewalType="renewalType"></ath-title>
      <div class="notice" v-if="checkAuth('renewalRule')">
        <div class="notice-desc"><i class="el-icon-bell" style="color: #fd9201"></i>续费订单，需达到继续率要求方可结算。点击查看</div>
        <div class="notice-rule" @click="noticeRule">续期单结算规则</div>
      </div>
      <topSearchForm @search="queryOrderList" :hiddenExport="!checkAuth('orderExport')" @export="exportPolicy" :showSwtich="!['3'].includes(userinfo.level)">
        <el-form :inline="true" class="rform" :model="dataForm" ref="rhform">
          <el-form-item label="" class="small">
            <div class="cell-border">
              <el-select class="big-left-select" v-model="dataForm.renewalTitle" placeholder="应续期日期">
                <el-option value="1" label="应续期日期"></el-option>
                <el-option value="2" label="投保日期"></el-option>
                <el-option value="3" label="宽限期满日"></el-option>
              </el-select>
              <a-range-picker class="small-date-picker" v-model="dataForm.creatTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
                <i class="icon-riqixuanze" slot="suffixIcon"></i>
              </a-range-picker>
            </div>
          </el-form-item>
          <el-form-item label="产品名称" class="small1">
            <el-input v-model="dataForm.productName" placeholder="请输入" clearable class="only-input"></el-input>
          </el-form-item>
          <el-form-item label="">
            <div class="cell-border">
              <el-select v-model="dataForm.policyHolder" placeholder="投保人" class="left-select">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
              <el-input class="right-input" type="text" v-model="dataForm.nameOrPh" placeholder="姓名/手机号" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="保单号">
            <el-input v-model="dataForm.plicyNum" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="交费方式">
            <el-select placeholder="全部" v-model="dataForm.payment" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="年交" value="1"></el-option>
              <el-option label="月交" value="2"></el-option>
              <el-option label="季交" value="3"></el-option>
              <el-option label="半年交" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="[1, 2].includes(userinfo.userLevel) && [1, 2].includes(userinfo.level * 1)">
            <div class="cell-border">
              <el-select
                class="left-select"
                v-model="dataForm.level"
                @change="
                  dataForm.mechanId = '';
                  dataForm.userId = '';
                "
                placeholder="出单团队"
              >
                <el-option label="出单团队" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select v-if="dataForm.level == 2" class="right-select" v-model="dataForm.mechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
              </el-select>
              <el-select v-else-if="dataForm.level == 3" class="right-select" v-model="dataForm.userId" clearable filterable>
                <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 只有二级团队显示 -->
          <el-form-item label="出单员工" v-if="[3].includes(userinfo.userLevel) && [2].includes(userinfo.level * 1)">
            <el-select v-model="dataForm.userId" clearable filterable>
              <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </topSearchForm>
      <el-tabs v-model="dataForm.renewal" @tab-click="queryOrderList" v-if="countData" :key="countData.count">
        <el-tab-pane label="全部" name="null"></el-tab-pane>
        <el-tab-pane :label="countData.count == 0 ? '待续费' : `待续费(${countData.count || 0})`" name="2"></el-tab-pane>
        <el-tab-pane label="已续费" name="5"></el-tab-pane>
        <el-tab-pane label="续费失败" name="6"></el-tab-pane>
      </el-tabs>
      <div v-loading="loading">
        <xfd-card :orderList="renewalPolicys" ref="child" @reload="getRenewalPolicys()"></xfd-card>
      </div>
      <el-pagination
        v-if="pageFlag"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="allData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="allData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.total"
      >
      </el-pagination>
    </div>
    <!-- 续期单结算规则 -->
    <xfdExplainModal ref="xfdExplainModal"></xfdExplainModal>
  </div>
</template>

<script>
import headBox from '@/components/head.vue';
import topSearchForm from '@/components/topSearchForm.vue';
import xfdCard from './components/order_xfd_card';
import xfdExplainModal from './components/xfdExplainModal';
import athTitle from './components/authorizationTitle';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data: () => ({
    userinfo: {},
    pageFlag: false,
    loading: true,
    num: 1, // 续费授权标题
    pageNum: 1,
    pageSize: 10,
    countData: null, // 统计数据
    allData: {}, // 全部数据列表
    renewalPolicys: [], // 续费数据列表
    renewalType: '2', // 保单类型 1 短险续保列表 2 长险续费列表
    dataForm: {
      renewalTitle: '1', // 应续费日期标题
      creatTime: [], // 日期
      productName: '', // 产品名称
      renewal: '2', // 续费状态
      nameOrPh: '', // 姓名或者手机
      policyHolder: '1', // 投保人
      plicyNum: '', // 保单号
      payment: '', // 交费方式
      level: '2', // 2出单团队/3出单员工
      mechanId: '', // 出单员工/团队id
      userId: ''
    },
    selectList: [], // 出单团队/员工列表
    userList: [],
    beginTime: '',
    endTime: '',
    childrenRefs: [],
    // screenWidth: document.body.clientWidth, // 屏幕宽度
    timer: false,
    userInfo: {}
  }),
  created() {
    // let begin = new Date();
    // let end = new Date();
    // begin = begin.getTime() - 59 * 24 * 3600 * 1000
    // let timeArr = [];
    // timeArr[0] = this.$tools.formatDate(begin) + " " + "00:00:00";
    // timeArr[1] = this.$tools.formatDate(end) + " " + "23:59:59";
    // this.dataForm.creatTime = timeArr;
    this.getUserInfo();
  },
  mounted() {
    this.userInfo = this.$tools.getLocal('userinfo');
    this.getRenewalPolicys();
  },
  methods: {
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {}
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.userList = res.data;
          }
        })
        .catch(e => {});
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map(item => {
        if (item.children.length == 0) {
          item.children = '';
        } else {
          this.handleDeptTree(item.children);
        }
        return item;
      });
      return val;
    },
    // 获取团队/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        }
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.selectList = res.data;
          }
        })
        .catch(e => {});
    },
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      this.userinfo = this.$tools.getLocal('userinfo');
      // 1一级团队 2二级团队 3员工
      if (data.userLevel == 1 || (data.level == 2 && data.userLevel == 2)) {
        // 一级团队默认出单团队
        this.dataForm.level = '2';
        this.getChildList(); // 获取出单团队列表
        this.getUserList();
      } else if (data.level == 2) {
        //二级团队没有出单团队，默认出单员工
        this.dataForm.level = '3';
        this.getUserList();
      }
    },
    // 获取参数
    getParams() {
      this.beginTime = this.dataForm.creatTime.length != 0 ? this.dataForm.creatTime[0] : '';
      this.endTime = this.dataForm.creatTime.length != 0 ? this.dataForm.creatTime[1] : '';
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        needPayTimeStart: this.dataForm.renewalTitle == '1' ? this.beginTime : '',
        needPayTimeEnd: this.dataForm.renewalTitle == '1' ? this.endTime : '',
        policyNo: this.dataForm.plicyNum,
        productName: this.dataForm.productName,
        policyerKey: this.dataForm.policyHolder == '1' ? this.dataForm.nameOrPh : '', // 搜索默认为投保人,
        insuranceKey: this.dataForm.policyHolder == '2' ? this.dataForm.nameOrPh : '',
        payType: this.dataForm.payment,
        type: this.dataForm.renewal,
        payTimeStart: this.dataForm.renewalTitle == '2' ? this.beginTime : '', // 投保开始时间 1应续费日期 2投保日期 3宽限期满日
        payTimeEnd: this.dataForm.renewalTitle == '2' ? this.endTime : '', // 投保结束时间
        lastPayTimeStart: this.dataForm.renewalTitle == '3' ? this.beginTime : '', // 到期开始时间
        lastPayTimeEnd: this.dataForm.renewalTitle == '3' ? this.endTime : '', // 到期结束时间
        renewalType: this.renewalType, // 保单类型 1 短险续保列表 2 长险续费列表
        mechanId: this.dataForm.mechanId, // 出单团队/员工id
        userId: this.dataForm.userId
      };
      if (params.type.includes('$')) {
        const arr = params.type.split('$');
        params.type = arr[0];
        params.isRenewal = arr[1];
      } else if (params.type == 'null') {
        delete params.type;
      }
      for (var key in params) {
        if (params[key] == '') {
          delete params[key];
        }
      }
      return params;
    },
    // 获取续费列表
    getRenewalPolicys() {
      this.loading = true;
      const query = this.getParams();
      query.pageNum = this.pageNum;
      query.pageSize = this.pageSize;
      this.getCount();
      this.$http({
        url: '/master/policy/queryRenewalPolicys',
        type: 'put',
        params: query
      }).then(res => {
        this.loading = false;
        this.pageFlag = false;
        this.allData = res;
        this.renewalPolicys = res.data;
        if (this.allData.total != 0) {
          this.pageFlag = true;
        }
      });
    },
    //查询
    queryOrderList() {
      this.pageNum = 1;
      this.getRenewalPolicys();
    },
    getCount() {
      const query = this.getParams();
      delete query.type;
      delete query.isRenewal;
      this.$http({
        url: '/master/policy/countRenewalPolicys',
        type: 'put',
        params: query
      }).then(res => {
        this.countData = res.data[0] || {};
      });
    },
    //导出
    exportPolicy() {
      const query = this.getParams();
      if (query.productName) {
        query.productName = this.handleProductName(query.productName);
      }
      const params = {
        path: '/master/policy/exportRenewalPolicys',
        query
      };
      const url = this.$router.resolve(params).href.replace('#/', '/');
      // 当前页面下载
      this.$tools.daochu(url);
    },
    noticeRule() {
      this.$refs.xfdExplainModal.open();
      this.$refs.xfdExplainModal.mechanUserType = this.userInfo.mechanUserType;
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRenewalPolicys();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getRenewalPolicys();
    },
    // 转译特殊字符
    handleProductName(name) {
      return name
        .replace(/\+/g, '%2B')
        .replace(/\-/g, '%2D')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace('\n', '%20');
    }
  },
  components: {
    xfdExplainModal,
    xfdCard,
    athTitle,
    topSearchForm,
    headBox
  }
};
</script>

<style lang="scss" scoped>
@import './order_xfd';
// @import "./components/common_form";
</style>